import React, { useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import observer from '../utils/observer';
import { Link } from 'react-router-dom';

const ArticleCard = ({
  articleImage,
  articleName,
  articleDate,
  articleUrl,
}) => {
  let newName;
  const imageRefValue = useRef(null);
  const date = new Date(articleDate);
  const dateOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  };
  const articleDateModified = date.toLocaleDateString('en-GB', dateOptions);

  if (articleName.length > 30) {
    newName = articleName.split('').splice(0, 28).join('').padEnd(31, '.');
  }

  useEffect(() => {
    observer(imageRefValue, 'lazy-load-image');
  }, [imageRefValue]);

  return (
    <div className="article-card">
      <Link
        to={articleUrl}
        target="_blank"
        className="article-card-image-container"
      >
        <img
          src={articleImage}
          alt="article"
          className="article-card-image lazy-load-image"
          ref={imageRefValue}
        />
      </Link>
      <Link
        to={articleUrl}
        target="_blank"
        className="article-card-name article-link"
      >
        {newName || articleName}
      </Link>
      <div className="article-card-bottom">
        <div className="article-card-date">{articleDateModified}.</div>
        <Link to={articleUrl} target="_blank" className="article-link">
          <FontAwesomeIcon
            icon={faArrowRight}
            className="article-card-arrow-icon"
          />
        </Link>
      </div>
    </div>
  );
};

export default ArticleCard;
